import { useState, useEffect } from 'react';
import type { Collection } from '../types';
import { apiClient } from '../api/client';

interface UseCollectionsResult {
  collections: Collection[];
  isLoading: boolean;
  error: string | null;
}

export function useCollections(): UseCollectionsResult {
  const [collections, setCollections] = useState<Collection[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchCollections() {
      try {
        setIsLoading(true);
        setError(null);
        const data = await apiClient.getCollections();
        if (!cancelled) {
          setCollections(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load collections');
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }

    fetchCollections();

    return () => {
      cancelled = true;
    };
  }, []);

  return { collections, isLoading, error };
}
